import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "../mock";
import logo from "../assets/logo_h.webp";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className="fixed top-0 left-0 right-0 z-40 transition-all duration-300"
      style={{
        background: scrolled ? "rgba(0,16,31,0.85)" : "transparent",
        backdropFilter: scrolled ? "blur(10px)" : "none",
        borderBottom: scrolled ? "1px solid rgba(177,205,255,0.12)" : "1px solid transparent",
      }}
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 h-[74px] flex items-center justify-between">
        <a href="#top" className="flex items-center">
          <img src={logo} alt="ChiDi - Chihuahua Digital" className="logo-white h-8 md:h-9 w-auto" />
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {NAV_LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              className="relative text-[15px] font-medium text-white/85 hover:text-white transition-colors duration-200 group"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 h-[2px] w-0 group-hover:w-full transition-all duration-300" style={{ background: "#e55b36" }} />
            </a>
          ))}
        </nav>

        <div className="hidden lg:block">
          <a
            href="#contacto"
            className="inline-flex items-center rounded-full px-6 py-2.5 text-[15px] font-semibold text-white transition-all duration-200 hover:-translate-y-0.5"
            style={{ background: "#e55b36" }}
          >
            Agendar Auditoría
          </a>
        </div>

        <button className="lg:hidden text-white" onClick={() => setOpen(!open)} aria-label="Menú">
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden px-5 pb-6 pt-2" style={{ background: "rgba(0,16,31,0.98)" }}>
          <div className="flex flex-col gap-1">
            {NAV_LINKS.map((l) => (
              <a key={l.label} href={l.href} onClick={() => setOpen(false)} className="py-3 text-white/90 border-b border-white/10 text-[16px]">
                {l.label}
              </a>
            ))}
            <a href="#contacto" onClick={() => setOpen(false)} className="mt-4 text-center rounded-full py-3 font-semibold text-white" style={{ background: "#e55b36" }}>
              Agendar Auditoría
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
